// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8398f2c0","977":"a8f2c052"}[chunkId] + ".chunk.js";
};